<div class="flex flex-row">
  @for (tag of tags; track tag) {
    <app-tag-atom
      [text]="tag.text"
      [url]="tag.url"
      class="mr-1"
    ></app-tag-atom>
  }
</div>
